import React from 'react';
import { Star, ShieldCheck, Sparkles, ArrowRight } from 'lucide-react';
import { SITE } from '../../mock';

export default function BookHero({ paymentLink }) {
  return (
    <section className="relative overflow-hidden">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[1100px] h-[700px] rounded-full bg-amber-300/[0.07] blur-3xl" />
        <div className="absolute top-40 right-10 w-[500px] h-[500px] rounded-full bg-amber-500/[0.05] blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 pt-16 md:pt-24 pb-12 md:pb-20">
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-flex items-center gap-2 rounded-full bg-amber-300/10 border border-amber-300/25 px-4 py-1.5 text-[11px] tracking-[0.22em] uppercase text-amber-200">
            <Sparkles size={12} /> Launch Offer · Save ₹100 + ₹12,000 in Bonuses
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center">
          <div>
            <p className="text-[11px] tracking-[0.25em] uppercase text-amber-300/80 mb-5">
              Stop chasing wealth. Start commanding it.
            </p>
            <h1 className="font-serif text-white text-[44px] leading-[1.02] md:text-[72px] md:leading-[1.02] tracking-tight">
              <span className="block bg-gradient-to-b from-white to-neutral-400 bg-clip-text text-transparent">
                You Are
              </span>
              <span className="block bg-gradient-to-b from-amber-100 to-amber-400 bg-clip-text text-transparent italic">
                The Magician
              </span>
            </h1>
            <p className="mt-6 text-neutral-400 text-[15px] md:text-[17px] leading-relaxed max-w-lg">
              The book that finally explains why hard work isn't making you rich — and the exact
              subconscious blueprint to break your income ceiling for good.
            </p>
            <p className="mt-4 text-neutral-500 text-[13px] md:text-[14px] leading-relaxed max-w-lg">
              A 100+ page manifestation manual built for ambitious souls who are tired of “think
              positive” advice. Real assignments. Real shifts. Real money.
            </p>

            <div className="mt-8 flex items-end gap-5">
              <div>
                <div className="flex items-baseline gap-3">
                  <span className="font-serif text-white text-[44px] md:text-[56px] leading-none">
                    ₹399
                  </span>
                  <span className="font-serif text-neutral-500 text-[22px] md:text-[26px] line-through">
                    ₹499
                  </span>
                </div>
                <p className="mt-1 text-[11px] tracking-[0.2em] uppercase text-amber-300/80">
                  Launch Price
                </p>
              </div>
              <div className="hidden sm:block h-12 w-px bg-white/10" />
              <div className="hidden sm:block">
                <p className="text-amber-200 text-[13px] font-medium">+ 6 Free Bonuses</p>
                <p className="text-neutral-500 text-[12px]">worth ₹12,000</p>
              </div>
            </div>

            <div className="mt-8 flex items-center gap-4 flex-wrap">
              <a
                href={paymentLink}
                target="_blank"
                rel="noreferrer"
                className="group inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-[15px] font-semibold text-navy-900 bg-gradient-to-b from-amber-200 to-amber-400 shadow-[0_10px_36px_-6px_rgba(251,191,36,0.55)] hover:-translate-y-[2px] hover:shadow-[0_16px_44px_-6px_rgba(251,191,36,0.75)] transition-all"
              >
                Get Instant Access — ₹399
                <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
              </a>
              <a
                href="#bonuses"
                className="inline-flex items-center gap-2 rounded-full px-6 py-3.5 text-[14px] text-neutral-200 border border-white/10 hover:border-amber-300/40 hover:text-white transition-colors"
              >
                See What's Inside
              </a>
            </div>

            <div className="mt-7 flex flex-wrap items-center gap-x-5 gap-y-2 text-[12px] text-neutral-400">
              <span className="inline-flex items-center gap-1.5">
                <ShieldCheck size={14} className="text-amber-300" /> 7-day refund promise
              </span>
              <span className="inline-flex items-center gap-1.5">
                Secure checkout · UPI / Card / Net Banking
              </span>
              <span className="inline-flex items-center gap-1.5">
                Read on any device
              </span>
            </div>

            <div className="mt-6 inline-flex items-center gap-3">
              <div className="flex items-center gap-0.5 text-amber-300">
                {[0, 1, 2, 3, 4].map((i) => (
                  <Star key={i} size={16} fill="currentColor" strokeWidth={0} />
                ))}
              </div>
              <span className="text-white text-sm font-medium">4.9</span>
              <span className="text-neutral-500 text-xs">Trusted by readers across India</span>
            </div>
          </div>

          <div className="relative">
            <div className="absolute -inset-6 bg-gradient-to-br from-amber-300/20 via-transparent to-transparent blur-2xl" />
            <div className="relative mx-auto max-w-md rounded-3xl overflow-hidden border border-white/10 bg-navy-900 shadow-[0_30px_80px_-20px_rgba(251,191,36,0.3)]">
              <img
                src={SITE.bookCover}
                alt="You Are The Magician — book cover"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
